import React from "react";
import NoContent from "../../../components/NoContent/NoContent";

interface NoPrescriptionsProps {
  shopUrl: string;
}

const NoPrescriptions = ({ shopUrl }: NoPrescriptionsProps) => {
  return (
    <NoContent
      imageSrc="/assets/images/no-prescriptions.svg"
      imageAlt="No prescriptions illustration"
      title="No Prescriptions On File"
      description={
        <>
          We don&apos;t see any active prescriptions for your pets <br />
          right now. If a prescription was recently written, it <br />
          may take up to 24 hours to appear here.
        </>
      }
      buttonText="Place an Order"
      buttonUrl={shopUrl}
    />
  );
};

export default NoPrescriptions;
